import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { m } from 'framer-motion';
import { gribbleAbi, gribbleContractAddress } from '../../utils/gribble_abi';
import './Mint.scss';
import poster from '../../assets/img/egg/mint-video.jpg';
import vid1 from '../../assets/img/egg/mint-video.webm';
import vid2 from '../../assets/img/egg/mint-video.mp4';
import Spinner from 'components/Spinner';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import { MintSuccessfulModal } from './MintSuccessfulModal';
import { useUser } from '../../hooks/useUser';
import { routes } from '../../routing/routes';
import { PlatformButton } from '../Button/PlatformButton';
import type { Moralis } from 'moralis';
import { WalletModal } from 'components/WalletModal/WalletModal';
import { Egg } from 'components/Egg/Egg';

export default function Mint() {
  const { moralis } = useUser();
  const { isAuthenticating, isAuthenticated, user, Moralis } = moralis;
  const [claimlistMintsRemaining, setClaimlistMintsRemaining] = useState(0);
  const [allowlistMintsRemaining, setAllowlistMintsRemaining] = useState(0);
  const [isClaiming, setIsClaiming] = useState(false);
  const [isMinting, setIsMinting] = useState(false);

  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
  const [mintedEggId, setMintedEggId] = useState(0);

  const [walletModalOpen, setWalletModalOpen] = useState(false);

  const [genesisAmt, setGenesisAmt] = useState(1);
  const [claimAmt, setClaimAmt] = useState(1);

  const [web3Provider, setweb3Provider] = useState<Moralis.MoralisWeb3Provider | null>(null);

  const updateMintAmt: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.valueAsNumber > 20) {
      e.target.value = String(20);
    }
    if (e.target.valueAsNumber > allowlistMintsRemaining) {
      e.target.value = String(allowlistMintsRemaining);
    }
    setGenesisAmt(e.target.valueAsNumber);
  };

  const updateClaimAmt: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.valueAsNumber > 20) {
      e.target.value = String(20);
    }
    if (e.target.valueAsNumber > claimlistMintsRemaining) {
      e.target.value = String(claimlistMintsRemaining);
    }
    setClaimAmt(e.target.valueAsNumber);
  };

  useEffect(() => {
    const setupWeb3 = async () => {
      let w3p = await Moralis.enableWeb3();
      setweb3Provider(w3p);
      await w3p.getNetwork().then(async (result) => {
        console.log('Web3 provider network:', result);
      });
    };

    setupWeb3()
      // make sure to catch any error
      .catch(console.error);
  }, [Moralis]);

  useEffect(() => {
    const setupAllowlists = async () => {
      if (!user) {
        console.error(`Moralis user was not found`);
        return;
      }
      if (isAuthenticated && web3Provider) {
        const ethers = Moralis.web3Library;
        const contract = new ethers.Contract(gribbleContractAddress!, gribbleAbi, web3Provider);
        console.log(user);
        console.log(user.get('ethAddress'));
        let allows = await contract.getAllowlistMintsRemaining(
          user.get('ethAddress').toLowerCase(),
        );
        let claims = await contract.getClaimlistMintsRemaining(
          user.get('ethAddress').toLowerCase(),
        );
        console.log(allows);
        console.log(claims);
        setAllowlistMintsRemaining(allows.toNumber());
        // We now set claims to 0 as none are available
        setClaimlistMintsRemaining(0);
      }
    };
    setupAllowlists();
  }, [
    isAuthenticated,
    user,
    web3Provider,
    Moralis.web3Library,
    isSuccessModalOpen,
    isClaiming,
    isMinting,
  ]);

  const mintGribble = async () => {
    if (!isAuthenticated) {
      return;
    }
    setIsMinting(true);
    const ethers = Moralis.web3Library; // get ethers.js library

    if (!web3Provider) {
      alert("Could not find web3 provider. This shouldn't happen");
      return;
    }
    //const web3Provider = await Moralis.enableWeb3(); // Get ethers.js web3Provider
    const { maxPriorityFeePerGas } = await web3Provider.getFeeData();

    const signer = web3Provider.getSigner();
    console.log(await signer.getChainId());
    const contract = new ethers.Contract(gribbleContractAddress!, gribbleAbi, signer);
    let bnAmt = genesisAmt * 0.03;

    const transaction = await contract.genesisMint(genesisAmt, {
      value: Moralis.Units.ETH(bnAmt),
      gasLimit: 400000 * genesisAmt,
      maxPriorityFeePerGas,
    });

    //TODO: Spinner Please

    console.log('no error on mint: ' + transaction.hash);
    try {
      const txReceipt = await transaction.wait();
      setAllowlistMintsRemaining(allowlistMintsRemaining - 1);
      setSuccessModalOpen(true);
      setMintedEggId(txReceipt.events[2].args.gribbleId.toNumber());
      setIsMinting(false);
    } catch (e) {
      console.error(e);
    }
  };

  const claimGribble = async () => {
    if (!isAuthenticated) {
      return;
    }
    setIsClaiming(true);
    const ethers = Moralis.web3Library; // get ethers.js library

    if (!web3Provider) {
      alert("Could not find web3 provider. This shouldn't happen");
      return;
    }

    const { maxPriorityFeePerGas } = await web3Provider.getFeeData();

    const signer = web3Provider.getSigner();
    console.log(await signer.getChainId());
    const contract = new ethers.Contract(gribbleContractAddress!, gribbleAbi, signer);

    const transaction = await contract.claimMint(claimAmt, {
      gasLimit: 400000 * claimAmt,
      maxPriorityFeePerGas,
    });

    //TODO: Spinner Please

    console.log('no error on mint: ' + transaction.hash);
    try {
      const txReceipt = await transaction.wait();
      // We now set claim mints to 0 as none are left after hatchening
      setClaimlistMintsRemaining(0);
      setSuccessModalOpen(true);
      setMintedEggId(txReceipt.events[2].args.gribbleId.toNumber());
      setIsClaiming(false);
    } catch (e) {
      console.error(e);
    }
  };

  function LoginButton() {
    return (
      <div className="mt-3">
        {isAuthenticating && Spinner({ color: 'white' })}
        {!isAuthenticating && (
          <button
            onClick={() => {
              setWalletModalOpen(true);
            }}
            className="btn btn-primary btn-md primary-mint-btn"
          >
            Connect Wallet
          </button>
        )}
      </div>
    );
  }

  function renderMustLoginDialog() {
    return (
      <div>
        <LoginButton />
        <p className="mt-4 mint-connect-wallet">
          Please connect your Ethereum wallet to proceed.
          <br />
          <strong>Mobile Users:</strong> Please connect using your Metamask&nbsp;app.
        </p>
      </div>
    );
  }

  const pageContent = (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="help"
    >
      <Helmet>
        <title>Mint - DuskBreakers</title>
        <meta
          name="description"
          content="New NFT Collection from DuskBreakers - The Gribbles - a play-to-evolve egg to incubation to hatch experience"
        />
      </Helmet>
      <div className="mint-page-wrapper">
        <video autoPlay loop controls={false} poster={poster} className="mint-video">
          <source src={vid1} type="video/webm" />
          <source src={vid2} type="video/mp4" />
        </video>

        <div className="mint-page-container">
          <div className="">
            <div className="title">
              <h2>Mint gribble egg nft</h2>
              <p>Mint your Gribble Egg NFT and join the incubation Eggsperience.</p>
            </div>
            <HorizontalDivider />
            {!isAuthenticated && renderMustLoginDialog()}

            {isAuthenticated && (
              <>
                {isClaiming && Spinner({ color: 'white' })}
                {claimlistMintsRemaining > 0 && !isClaiming && (
                  <div className="mint-page-mint-available">
                    <input type="number" value={claimAmt} onChange={updateClaimAmt} />
                    <button
                      onClick={async () => await claimGribble()}
                      className="btn btn-primary btn-md primary-mint-btn"
                    >
                      Claim Gribble Egg
                    </button>
                    <div className="mint-page-info">
                      <p>Claimlist Left: </p>
                      <span>{claimlistMintsRemaining}</span>
                      <span className="mint-page-dot">•</span>
                      <p>Price: </p>
                      <span>Gas Only</span>
                    </div>
                  </div>
                )}
                {isMinting && Spinner({ color: 'white' })}
                {allowlistMintsRemaining > 0 && !isMinting && (
                  <div className="mint-page-mint-available">
                    <input type="number" value={genesisAmt} onChange={updateMintAmt} />

                    <button
                      onClick={async () => await mintGribble()}
                      className="btn btn-primary btn-md primary-mint-btn"
                    >
                      Mint Gribble Egg
                    </button>
                    <div className="mint-page-info">
                      <p>Mints Left: </p>
                      <span>{allowlistMintsRemaining}</span>
                      <span className="mint-page-dot">•</span>
                      <p>Price: </p>
                      <span>0.03 ETH + Gas</span>
                    </div>
                  </div>
                )}
                {allowlistMintsRemaining === 0 && claimlistMintsRemaining === 0 && (
                  <div>
                    <div className="stacked-aligned-buttons">
                      <PlatformButton
                        platform="windows"
                        text="Play to Mint"
                        link={routes.launcher()}
                      />
                      <PlatformButton platform="macos" text="Play to Mint" link={routes.game()} />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {isSuccessModalOpen && (
        <MintSuccessfulModal
          eggId={mintedEggId}
          onClick={() => setSuccessModalOpen(false)}
          mintsLeft={allowlistMintsRemaining + claimlistMintsRemaining}
        />
      )}
      {walletModalOpen && <WalletModal onClose={() => setWalletModalOpen(false)} />}
    </m.main>
  );

  return <Egg>{pageContent}</Egg>;
}
